// 引入数据配置文件
import { fun_PostAction } from "@/api/index";
import CaLock from "@/components/common/calock";
import BiddingRegistrationInformation from "../biddingRegistrationInformation/index.vue";
import Section from "../section/index.vue";
import RequirementManager from "../requirementManager/index.vue";
import ProjectManager from "../projectManager/index.vue";
import TenderUnion from "../tenderUnion/index.vue";
import Other from "../other/index.vue";
import { Loading } from "element-ui";
// 引入历史核验页面
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: sessionStorage.getItem("workbenchMenu"),
      // 工作台状态
      workbenchState: false,
      // 顶部是否显示
      pageHeader: true,
      // tab切换
      activeName: "1",
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 甲方确认标志
      isTenderSignature: null,
      // 操作类型
      controllerFlg: null, // 操作标志
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType"), // 用户类型
      // 表单对象
      form: {
        id: null, // 主键
        state: null, // 状态
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      state: null, // 状态
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // tab联合体招标协议提示是否显示
      tabComboTip: false,
      // tab联合体招标协议提示内容
      tabComboTipText: "",
      // tab招标登记信息提示是否显示
      tabBidRegTip: false,
      // tab招标登记信息提示内容
      tabBidRegTipText: "",
      // tab项目标段信息提示是否显示
      tabSectionTip: false,
      // tab项目标段信息提示内容
      tabSectionTipText: "",
      // 用于判断状态图片
      flagState: null,
      // 一览tab切换状态
      tabName: "1",
      // 招标登记信息提交判断条件
      bidSubObj: null,
      // 提交用于判断的flag
      flag: false
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    BiddingRegistrationInformation, // 招标登记信息
    Section, // 项目标段详情
    RequirementManager, // 招标对投标人要求
    ProjectManager, // 招标对项目负责人要求
    TenderUnion, // 联合体招标协议
    Other, // 其他
    AuditHistoryRecord, // 核验记录
  },
  // 接收来自父组件的数据
  props: {
    // 用于判断是否为子组件
    isComponent: {
      type: Boolean,
      default: false
    }
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 判断是否为子组件
    if (!this.isComponent) {
      // 获取主键
      this.id = this.$route.query.id;
      // 获取确认标识
      this.isTenderSignature = this.$route.query.isTenderSignature;
      // 获取操作标识
      this.controllerFlg = this.$route.query.controllerFlg;
      // 获取一览tab状态
      this.tabName = this.$route.query.activeName;
      // 判断一览tab切换状态
      if (this.tabName === "2") return;
      // 获取详情
      this.fun_GetDetail();
    }
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail(state, next) {
      // 状态为空时
      if (!state) {
        // 打开遮罩
        this.fun_Loading();
      }
      // 发起请求
      fun_PostAction("/tenderRegistration/detail", {
        id: this.id,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 不为新增的时候
          if (this.controllerFlg != "insert") {
            // 如果主键为空
            if(!this.id){
              // 重新赋值主键
              this.id = data.model.id;
            }
            // 获取状态用于判断显示图片
            this.flagState = data.model.state;
            // 工作台状态
            this.workbenchState = data.workbenchState;
            // 表格数据
            this.$refs.biddingRegistrationInformation.form = data.model;
            // 设置子页面甲方确认
            this.$refs.biddingRegistrationInformation.fun_GetTenderSignature(
              data
            );
            // 判断是否为点击流程或下一步上一步执行的详情接口
            if (!next) {
              // 执行判断是否填写内容
              this.$refs.biddingRegistrationInformation.fun_GetInitializeStepsIsData();
            }
            // 表单数据
            this.$refs.requirementManager.form = data.model;
            // 表单数据
            this.$refs.tenderUnion.form = data.model;
            // 设置状态
            this.state = data.model.state;
            // 设置甲方确认
            this.fun_GetTenderSignature(data);
            // 如果是详情
            if (this.controllerFlg == "detail") {
              // 表格数据
              this.$refs.other.form = data.model;
            }
          }
          // 调用子页面方法
          this.fun_GetBiddingRegistrationInformation();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
        // 状态为空时
        if (!state) {
          // 加载框取消
          this.fullLoading.close();
        }
      });
    },
    /**
     * 调用子页面方法
     */
    fun_GetBiddingRegistrationInformation() {
      // 赋值子页面主键
      this.$refs.biddingRegistrationInformation.id = this.id;
      // 赋值子页面操作标志
      this.$refs.biddingRegistrationInformation.controllerFlg = this.controllerFlg;
      // 调用子页面方法
      this.$refs.biddingRegistrationInformation.fun_Open();
      // 赋值子页面主键
      this.$refs.section.id = this.id;
      // 赋值子页面操作标志
      this.$refs.section.controllerFlg = this.controllerFlg;
      // 调用子页面方法
      this.$refs.section.fun_Open();
      // 赋值子页面主键
      this.$refs.requirementManager.id = this.id;
      // 赋值子页面操作标志
      this.$refs.requirementManager.controllerFlg = this.controllerFlg;
      // 调用子页面方法
      this.$refs.requirementManager.fun_Open();
      // 赋值子页面主键
      this.$refs.projectManager.id = this.id;
      // 赋值子页面操作标志
      this.$refs.projectManager.controllerFlg = this.controllerFlg;
      // 调用子页面方法
      this.$refs.projectManager.fun_Open();
      // 赋值子页面主键
      this.$refs.tenderUnion.id = this.id;
      // 赋值子页面操作标志
      this.$refs.tenderUnion.controllerFlg = this.controllerFlg;
      // 调用子页面方法
      this.$refs.tenderUnion.fun_Open();
      // 如果是详情
      if (this.controllerFlg == "detail") {
        // 表格数据
        this.$refs.other.id = this.id;
        // 调用子页面方法
        this.$refs.other.fun_Open();
      }
    },
    /**
     * 设置联合体招标单位
     */
    fun_SerTenderUnion(tenderUnionCorpId, tenderUnionCorpName) {
      // 赋值子页面联合体招标单位编号
      this.$refs.tenderUnion.form.unionBasicInfoId = tenderUnionCorpId;
      // 赋值子页面联合体招标单位名称
      this.$refs.tenderUnion.form.unionCorpName = tenderUnionCorpName;
    },
    /**
     * 招标人和监管部门管理接口
     * @author 任少杰
     */
    fun_GetCorpRegulators(tenderCorpId, regulators) {
      // 可否进行下一步操作
      let flag = false;
      // 发起请求
      fun_PostAction("/corpRegulators/getCorpRegulators", {
        corpId: tenderCorpId,
        regulators: regulators
      }).then(res => {
        // 结构res.data
        const { result } = res.data;
        // 请求成功
        if (result) {
          flag = true;
        } else {
          flag = false;
        }
      });
      // 已开标
      return flag;
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      // 赋值招标人意见
      this.$refs.biddingRegistrationInformation.form.tenderOpinion =
        data.tenderOpinion;
      // 赋值招标人意见
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion;
      // 赋值招标人签章确认编号
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId;
      // 赋值招标人签章状态
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState;
      // 赋值添加标记
      this.tenderSignedForm.isDeregulation = data.isDeregulation;
      // 赋值招标人盖章确认的招标监管部门
      this.tenderSignedForm.esRegulators = data.esRegulators;
      // 赋值招标人盖章确认的招标监管流程
      this.tenderSignedForm.esProcessType = data.esProcessType;
      // 赋值招标人盖章确认权限编号
      this.tenderSignedForm.esInvitationId = data.esInvitationId;
      // 赋值招标人盖章的数字签名
      this.tenderSignedForm.tenderStampData = data.tenderStampData;
      // 表名
      this.tenderSignedForm.table = data.model.tableName;
      // 字段
      this.tenderSignedForm.key = data.model.keyState;
      // 数据编号
      this.tenderSignedForm.recordNumber = data.model.id;
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (
        this.$refs.biddingRegistrationInformation.form.tenderOpinion != "" &&
        this.$refs.biddingRegistrationInformation.form.tenderOpinion != null
      ) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.$refs.biddingRegistrationInformation.form.tenderOpinion;
      }
      // 状态赋值
      this.$refs.biddingRegistrationInformation.form.state = e;
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.$refs.biddingRegistrationInformation.form.tenderPrjName +
        this.$refs.biddingRegistrationInformation.form.id;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },
    /**
     * 递归验证招标登记信息表单
     */
    fun_GetFormValidate(index, state, val) {
      // 验证表单
      this.$refs.biddingRegistrationInformation.$refs.collapseForm.$refs.enInform.validate(
        valid => {
          // 验证通过
          if (valid) {
            // 判断当前下标是否为最长
            if (
              index ===
              this.$refs.biddingRegistrationInformation.stepsList.length - 1
            ) {
              // 改变标识
              this.flag = true;
              // 执行验证提交方法
              this.fun_PostSubmit(state, val);
            } else {
              // 获取表单数据
              this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
                index + 1
              ].formList;
              this.$refs.biddingRegistrationInformation.fun_Open();
              // 继续递归
              this.$nextTick(() => {
                this.fun_GetFormValidate(index + 1, state, val);
              });
            }
          } else {
            // tab切换
            this.activeName = "1";
            // 改变标识
            this.flag = false;
            // 显示当前流程
            this.$refs.biddingRegistrationInformation.stepsActive = index;
            // 错误提示
            this.$alert(
              "招标登记信息存在未填写或错误，请根据提示完善内容！",
              "warning"
            );
            // 验证不通过
            return false;
          }
        }
      );
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit(state, val) {
      // 声明标识
      this.flag = true;
      // 遍历错误消息
      for (let i in this.$refs.biddingRegistrationInformation.errRules) {
        // 设置为空
        this.$refs.biddingRegistrationInformation.errRules[i] = null;
      }
      // 状态赋值
      this.$refs.biddingRegistrationInformation.form.state = state;
      // 如果是保存 不进行其他验证
      if (state == "bc") {
        this.fun_InUpd(state);
      } else {
        // 声明获取招标登记信息流程数据
        const bidStepsList = this.$refs.biddingRegistrationInformation
          .stepsList;
        // 验证
        this.$refs.biddingRegistrationInformation.$refs.collapseForm.$refs.enInform.validate(
          valid => {
            // 判断是否验证通过
            if (valid) {
              // 从第一个流程开始验证
              // 获取表单数据
              this.$refs.biddingRegistrationInformation.formConfigList =
                bidStepsList[0].formList;
              // 显示当前流程
              this.$refs.biddingRegistrationInformation.stepsActive = 0;
              this.$refs.biddingRegistrationInformation.fun_Open();
              // 递归验证表单
              // this.fun_GetFormValidate(0, state, val);
              this.$nextTick(() => {
                this.fun_GetFormValidate(0, state, val);
              });
            } else {
              // 改变标识
              this.flag = false;
              // tab切换
              this.activeName = "1";
              // 错误提示
              this.$alert(
                "招标登记信息存在未填写或错误，请根据提示完善内容！",
                "warning"
              );
              // 验证不通过
              return false;
            }
          }
        );
      }
    },
    /**
     * 各页面判断条件并执行提交方法
     */
    fun_PostSubmit(state, val) {
      // 判断是否通过
      if (!this.flag) return;
      // 如果标段数为0时
      if (
        parseInt(
          this.$refs.biddingRegistrationInformation.form.sectionQuantity
        ) === 0
      ) {
        // 返回错误消息
        this.$refs.biddingRegistrationInformation.errRules.sectionQuantity =
          "标段数不能为0！";
        // tab切换
        this.activeName = "1";
        // tab显示提示内容
        this.tabBidRegTip = true;
        this.tabBidRegTipText = "标段数不能为0！";
        // 流程
        var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
        // 获取表单数据
        this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
          stepsActive
        ].formList;
        // 执行招标登记信息模块判断方法
        this.$refs.biddingRegistrationInformation.fun_GetPrequalificationTypeStyle();
        // 错误提示
        this.$alert("标段数不能为0！", "warning");
        // 改变标识
        this.flag = false;
        return false;
      }
      // 标段数不为空时
      if (
        this.$refs.biddingRegistrationInformation.form.sectionQuantity != "" &&
        this.$refs.biddingRegistrationInformation.form.sectionQuantity != null
      ) {
        // 如果录入的标段数不一致时
        if (
          this.$refs.section.tableData.length !=
          parseInt(
            this.$refs.biddingRegistrationInformation.form.sectionQuantity
          )
        ) {
          // 返回错误消息
          this.$refs.biddingRegistrationInformation.errRules.sectionQuantity =
            "该输入项应与项目标段信息数量一致！";
          // tab切换
          this.activeName = "1";
          // tab显示提示内容
          this.tabBidRegTip = true;
          this.tabSectionTip = true;
          this.tabBidRegTipText = "标段数应与项目标段信息数量一致！";
          this.tabSectionTipText = "标段数应与项目标段信息数量一致！";
          // 流程
          var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
          // 获取表单数据
          this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
            stepsActive
          ].formList;
          // 执行招标登记信息模块判断方法
          this.$refs.biddingRegistrationInformation.fun_GetPrequalificationTypeStyle();
          // 错误提示
          this.$alert("标段数应与项目标段信息数量一致！", "warning");
          // 改变标识
          this.flag = false;
          return false;
        }
      }
      // 如果是电子标
      if (this.$refs.biddingRegistrationInformation.form.ebsFlag == "1") {
        // 是否允许走电子标
        let allowEbs = false;
        // 获取招标类别
        let tenderClassNum = this.$refs.biddingRegistrationInformation.form
          .tenderClassNum;
      }
      // 如果是非电子标
      else {
        // 如果是不需要项目负责人
        if (this.$refs.biddingRegistrationInformation.form.isNeedPm == "0") {
          // 如果项目负责人要求数量大于0
          if (this.$refs.projectManager.formObj.tableData.length > 0) {
            // 返回错误消息
            this.$refs.biddingRegistrationInformation.errRules.isNeedPm =
              "若“是否需要项目负责人/总监”选择“否”，则“招标对项目负责人/总监的要求”应该为空，无需填写！";
            // tab切换
            this.activeName = "1";
            // tab显示提示内容
            this.tabBidRegTip = true;
            this.tabBidRegTipText =
              "若“是否需要项目负责人/总监”选择“否”，则“招标对项目负责人/总监的要求”应该为空，无需填写！";
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(
              "若“是否需要项目负责人/总监”选择“否”，则“招标对项目负责人/总监的要求”应该为空，无需填写！",
              "warning"
            );
            // 改变标识
            this.flag = false;
            return false;
          }
        }
        // 能否选择非电子标判断
        if (
          !this.fun_GetCorpRegulators(
            this.$refs.biddingRegistrationInformation.form.tenderCorpId,
            this.$refs.biddingRegistrationInformation.form.regulators
          )
        ) {
          // 获取招标类别
          let tenderClassNum = this.$refs.biddingRegistrationInformation.form
            .tenderClassNum;
          // 如果招标类别是"工程总承包招标"或者"工程施工招标"或者"工程服务招标"或者"工程货物招标"
          if (
            tenderClassNum == "201510200919130004" ||
            tenderClassNum == "201510200920240006" ||
            tenderClassNum == "201510200928550010" ||
            tenderClassNum == "201510200928400009"
          ) {
            // 返回错误消息
            this.$refs.biddingRegistrationInformation.errRules.ebsFlag =
              "招标类别选择工程服务招标、工程货物招标、工程总承包招标时，必须选择电子招标！";
            // tab切换
            this.activeName = "1";
            // tab显示提示内容
            this.tabBidRegTip = true;
            this.tabBidRegTipText =
              "招标类别选择工程服务招标、工程货物招标、工程总承包招标时，必须选择电子招标！";
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(
              "招标类别选择工程服务招标、工程货物招标、工程总承包招标时，必须选择电子招标！",
              "warning"
            );
            // 改变标识
            this.flag = false;
            return false;
          }
        }
      }
      // 如果选择招标联合体
      if (this.$refs.biddingRegistrationInformation.form.isUnionTender == "1") {
        // 如果未录入招标联合体单位
        if (this.$refs.tenderUnion.detailTableData.length == 0) {
          // tab切换
          this.activeName = "5";
          // tab显示提示内容
          this.tabComboTip = true;
          this.tabComboTipText =
            "若“招标单位是否联合体”选择“是”，则需录入“联合体招标协议”信息！";
          // 错误提示
          this.$alert(
            "若“招标单位是否联合体”选择“是”，则需录入“联合体招标协议”信息！",
            "warning"
          );
          // 改变标识
          this.flag = false;
          return false;
        }
        // 如果联合体招标协议备注为空
        if (
          this.$refs.tenderUnion.form.tenderUnionDescription == "" ||
          this.$refs.tenderUnion.form.tenderUnionDescription == null
        ) {
          // 返回错误消息
          this.$refs.tenderUnion.errRules.tenderUnionDescription =
            "请填写备注！";
          // tab切换
          this.activeName = "5";
          // tab显示提示内容
          this.tabComboTip = true;
          this.tabComboTipText = "请填写备注！";
          // 错误提示
          this.$alert("请填写备注！", "warning");
          // 改变标识
          this.flag = false;
          return false;
        }
      }
      // 如果不是招标联合体
      else {
        // 如果录入招标联合体单位
        if (this.$refs.tenderUnion.detailTableData.length > 0) {
          // tab切换
          this.activeName = "5";
          // tab显示提示内容
          this.tabComboTip = true;
          this.tabComboTipText =
            "若“招标单位是否联合体”选择“否”，则“联合体招标协议”应该为空，无需填写";
          // 错误提示
          this.$alert(
            "若“招标单位是否联合体”选择“否”，则“联合体招标协议”应该为空，无需填写！",
            "warning"
          );
          // 改变标识
          this.flag = false;
          return false;
        }
      }
      // 改变标识
      this.flag = true;
      // tab不显示提示内容
      this.tabComboTip = false;
      // tab不显示提示内容
      this.tabBidRegTip = false;
      // tab不显示提示内容
      this.tabSectionTip = false;
      // 判断标识
      if (this.flag) {
        // 验证招标对投标人要求
        this.$refs.requirementManager.$refs.ruleForm.validate(valid => {
          // 验证通过
          if (valid) {
            // 改变标识
            this.flag = true;
          } else {
            // 改变标识
            this.flag = false;
            // 错误提示
            this.$alert(
              "招标对投标人要求存在未填写或错误，请根据提示完善内容！",
              "warning"
            );
            // 验证不通过
            return false;
          }
        });
      }
      // 判断标识
      if (this.flag) {
        // 验证招标对项目负责人/总监要求
        this.$refs.projectManager.$refs.ruleForm.validate(valid => {
          // 验证通过
          if (valid) {
            // 改变标识
            this.flag = true;
          } else {
            // 改变标识
            this.flag = false;
            // 错误提示
            this.$alert(
              "招标对项目负责人/总监要求存在未填写或错误，请根据提示完善内容！",
              "warning"
            );
            // 验证不通过
            return false;
          }
        });
      }
      // 判断标识
      if (this.flag) {
        // 验证联合体招标协议
        this.$refs.other.$refs.collapseForm.$refs.enInform.validate(valid => {
          // 验证通过
          if (valid) {
            // 改变标识
            this.flag = true;
          } else {
            // 改变标识
            this.flag = false;
            // 错误提示
            this.$alert(
              "联合体招标协议存在未填写或错误，请根据提示完善内容！",
              "warning"
            );
            // 验证不通过
            return false;
          }
        });
      }
      // 判断标识
      if (this.flag) {
        // 验证文件是否上传
        this.fun_FileValidated(state, val);
      }
    },
    /**
     * 验证文件是否上传
     * @author shuhua
     */
    fun_FileValidated(state, val) {
      // 发起请求
      fun_PostAction("/tenderRegistration/fileValidated", {
        ...this.$refs.biddingRegistrationInformation.form,
        isUnionTender: this.$refs.biddingRegistrationInformation.form
          .isUnionTender,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 如果是提交
          if (state == "tj") {
            // 点击弹窗确认
            if (val === "biddingRegistrationVerifyDialog") {
              // 开启弹窗
              this.$refs.caLock.dialogCalock = true;
              // 签名数据, 交易人名称和日期
              this.$refs.caLock.data =
                this.$refs.biddingRegistrationInformation.form.constructionId +
                this.$refs.biddingRegistrationInformation.form.tenderPrjName +
                this.$refs.biddingRegistrationInformation.form.tenderTypeNum +
                this.$refs.biddingRegistrationInformation.form.ebsFlag +
                this.$refs.biddingRegistrationInformation.form.regulators;
              // 状态
              this.$refs.caLock.state = state;
            } else {
              // 传递数据
              this.$refs.biddingRegistrationInformation.$refs.biddingRegistrationVerifyDialog.form = this.$refs.biddingRegistrationInformation.formData;
              // 打开弹窗
              this.$refs.biddingRegistrationInformation.$refs.biddingRegistrationVerifyDialog.dialogVisible = true;
            }
          } else {
            this.fun_InUpd(state);
          }
        } else {
          // 判断是否存在值 招标登记信息附件
          if (data.file) {
            // tab切换
            this.activeName = "1";
            // 显示提示
            this.tabBidRegTip = true;
            // tab切换提示
            this.tabBidRegTipText = data.file;
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 1);
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(data.file, "warning");
          }
          // 联合体招标协议附件
          else if (data.unionFile) {
            // tab切换
            this.activeName = "5";
            // 显示提示
            this.tabComboTip = true;
            // tab切换提示
            this.tabComboTipText = data.unionFile;
            // 错误提示
            this.$alert(data.unionFile, "warning");
          }
          // 项目名称
          else if (data.tenderPrjName) {
            // tab切换
            this.activeName = "1";
            // 显示提示
            this.tabBidRegTip = true;
            // tab切换提示
            this.tabBidRegTipText = data.tenderPrjName;
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
            // 返回错误消息
            this.$refs.biddingRegistrationInformation.errRules.tenderPrjName =
              data.tenderPrjName;
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(data.tenderPrjName, "warning");
          }
          // 备案编号
          else if (data.agencyId) {
            // tab切换
            this.activeName = "1";
            // 显示提示
            this.tabBidRegTip = true;
            // tab切换提示
            this.tabBidRegTipText = data.agencyId;
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
            // 返回错误消息
            this.$refs.biddingRegistrationInformation.errRules.agencyId =
              data.agencyId;
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(data.agencyId, "warning");
          }
          // 评标办法
          else if (data.evaluationMethod) {
            // tab切换
            this.activeName = "1";
            // 显示提示
            this.tabBidRegTip = true;
            // tab切换提示
            this.tabBidRegTipText = data.evaluationMethod;
            // 流程
            var stepsActive = (this.$refs.biddingRegistrationInformation.stepsActive = 0);
            // 返回错误消息
            this.$refs.biddingRegistrationInformation.errRules.evaluationMethod =
              data.evaluationMethod;
            // 获取表单数据
            this.$refs.biddingRegistrationInformation.formConfigList = this.$refs.biddingRegistrationInformation.stepsList[
              stepsActive
            ].formList;
            // 错误提示
            this.$alert(data.evaluationMethod, "warning");
          } else {
            // 错误提示
            this.$alert(msg, "warning");
          }
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.$refs.biddingRegistrationInformation.form.lockNo = lockNo;
      // 赋值数字签名
      this.$refs.biddingRegistrationInformation.form.digitalSignature = digitalSignature;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 提交的方法
        this.fun_InUpd("tj");
      }
    },
    /**
     * 保存修改
     */
    fun_InUpd(state) {
      if (!this.$refs.biddingRegistrationInformation.form.prjName) {
        // 错误提示
        this.$message.info("请优先选择项目登记信息！");
        // 改变标识
        return false;
      } else {
        this.state = state;
        this.form.state = state;
        this.$refs.tenderUnion.form.state = state;
        // 打开遮罩
        this.fun_Loading();
        // 发起请求
        fun_PostAction("tenderRegistration/insUpd", {
          ...this.$refs.biddingRegistrationInformation.form,
          ...this.$refs.requirementManager.form,
          ...this.$refs.tenderUnion.form,
          isUnionTender: this.$refs.biddingRegistrationInformation.form
            .isUnionTender,
          list: JSON.stringify(this.$refs.section.tableData),
          requirementList: JSON.stringify(
            this.$refs.requirementManager.formObj.tableData
          ),
          projectManagerList: JSON.stringify(
            this.$refs.projectManager.formObj.tableData
          ),
          tenderUnionDetailList: JSON.stringify(
            this.$refs.tenderUnion.detailTableData
          ),
          controllerFlg: this.controllerFlg
        }).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;

          // 操作成功
          if (result) {
            // 加载框取消
            this.fullLoading.close();
            // 操作成功
            this.$message.success(msg);
            // 回传id
            this.id = data.id;
            // 设置为修改状态
            this.controllerFlg = "update";
            this.$refs.biddingRegistrationInformation.controllerFlg = "update";
            // 获取详情
            this.fun_GetDetail(state, "next");
            // 提交返回
            if (state == "tj") {
              // 返回一览
              this.$router.back();
            }
          } else {
            // 加载框取消
            this.fullLoading.close();
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.$refs.biddingRegistrationInformation.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
        });
      }
    },

    /**
     * 下一步保存修改
     */
    fun_NextInUpd(state) {
      if (!this.$refs.biddingRegistrationInformation.form.prjName) {
        // 错误提示
        this.$message.error("请优先选择项目登记信息！");
        // 改变标识
        return false;
      } else {
        this.state = state;
        this.form.state = state;
        this.$refs.tenderUnion.form.state = state;
        // 打开遮罩
        this.fun_Loading();
        // 发起请求
        fun_PostAction("tenderRegistration/insUpd", {
          ...this.$refs.biddingRegistrationInformation.form,
          ...this.$refs.requirementManager.form,
          ...this.$refs.tenderUnion.form,
          isUnionTender: this.$refs.biddingRegistrationInformation.form
            .isUnionTender,
          list: JSON.stringify(this.$refs.section.tableData),
          requirementList: JSON.stringify(
            this.$refs.requirementManager.formObj.tableData
          ),
          projectManagerList: JSON.stringify(
            this.$refs.projectManager.formObj.tableData
          ),
          tenderUnionDetailList: JSON.stringify(
            this.$refs.tenderUnion.detailTableData
          ),
          controllerFlg: this.controllerFlg
        }).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          if (result) {
            // 回传id
            this.id = data.id;
            // 设置为修改状态
            this.controllerFlg = "update";
            this.$refs.biddingRegistrationInformation.controllerFlg = "update";
            // 获取详情
            this.fun_GetDetail(state, "next");
            // 提交返回
            if (state == "tj") {
              // 加载框取消
              this.fullLoading.close();
              // 返回一览
              this.$router.back();
            }
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.$refs.biddingRegistrationInformation.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
        });
      }
    },
    /**
     * tab切换方法
     */
    fun_HandleClick(tab, event) {
      // 不等于详情
      if (this.controllerFlg != "detail") {
        // 调用主页面保存方法
        this.fun_NextInUpd("bc");
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行加载，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },

    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    }
  }
};
